import styled from "styled-components";

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 24px 0;
  ${({ theme }) => theme.smartphone} {
    justify-content: center;
  }
`;

export const PaginationBar = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 12px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    padding: 12px 16px;
  }
`;

export const ShowingLabel = styled.span`
  font-family: Roboto;
  font-size: 14px;
  color: #475061;
`;

export const PageSizeSelector = styled.select`
  background-color: #f4f5f5;
  border: none;
  border-radius: 4px;
  padding: 8px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  color: #475061;
  cursor: pointer;
  outline: none;
`;

export const ResultsCount = styled.span`
  font-family: Roboto;
  font-size: 14px;
  color: #475061;
  strong {
    font-weight: bold;
  }
`;

export const Separator = styled.span`
  color: #e8e9ea;
  font-size: 14px;
  ${({ theme }) => theme.smartphone} {
    display: none;
  }
`;

export const NavButton = styled.button`
  width: 40px;
  height: 40px;
  background-color: #f4f5f5;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #475061;
  &:hover:not(:disabled) {
    background-color: #e0e1e2;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const PageIndicator = styled.span`
  background-color: #f4f5f5;
  border-radius: 4px;
  padding: 8px 16px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  color: #475061;
`;

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
